import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'tangram-ai-title-desc-editor',
  templateUrl: './ai-title-desc-editor.component.html',
  styleUrls: ['./ai-title-desc-editor.component.scss'],
})
export class AiTitleDescEditorComponent implements OnChanges {
  @Input() aiTitle: string = '';
  @Input() aiDescription: string = '';
  @Input() isLoading: boolean = false;

  @Output() applyTitle       = new EventEmitter<string>();
  @Output() applyDescription = new EventEmitter<string>();
  @Output() regenerate       = new EventEmitter<void>();

  editingTitle = false;
  editingDesc  = false;
  editedTitle  = '';
  editedDesc   = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.aiTitle && changes.aiTitle.currentValue) {
      this.editedTitle   = changes.aiTitle.currentValue;
      this.editingTitle  = false;
    }
    if (changes.aiDescription && changes.aiDescription.currentValue) {
      this.editedDesc   = changes.aiDescription.currentValue;
      this.editingDesc  = false;
    }
  }

  startEditTitle(): void {
    this.editedTitle  = this.aiTitle;
    this.editingTitle = true;
  }

  startEditDesc(): void {
    this.editedDesc  = this.aiDescription;
    this.editingDesc = true;
  }

  confirmTitle(): void {
    this.applyTitle.emit(this.editedTitle.trim() || this.aiTitle);
    this.editingTitle = false;
  }

  confirmDesc(): void {
    this.applyDescription.emit(this.editedDesc.trim() || this.aiDescription);
    this.editingDesc = false;
  }

  get hasContent(): boolean {
    return !!(this.aiTitle || this.aiDescription);
  }
}
